import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../components/elements/LoadingButton";
import SubTitle from "../../components/elements/SubTitle";
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layouts/components/AppCard";
import AllInboxRoundedIcon from '@material-ui/icons/AllInboxRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import FieldCounter from "../../components/elements/FieldCounter";
import {setStore} from "trim-redux";
import AppCardLoader from "../../components/Skeletons/AppCardLoader";
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import Button from "@material-ui/core/Button/Button";
import {connect} from "trim-redux";
import {updateRedux} from "../../../config/Security";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Hidden from "@material-ui/core/Hidden/Hidden";
import {Icon} from "@material-ui/core";
import StatusChooser from "./components/StatusChooser";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import Typography from "@material-ui/core/Typography/Typography";
import Link from "@material-ui/core/Link/Link";
import FileChooserSingle from "../fileManager/Components/FileChooserSingle";
import Divider from "@material-ui/core/Divider/Divider";
import ImageViewer from "../../components/elements/ImageViewer";
import ProductChooser from "./components/ProductChooser";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import {currencySymbol} from "../../../config/values";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import ImageGallery from "../fileManager/Components/ImageGallery";
import OrderFiles from "../fileManager/Components/OrderFiles";


class MakeOrder extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
    }
    state = {
        fields:{
            title:"",
            description:"",
            tracking_code:"",
            customer_address:"",
            customer_phone:"",
            target_link:"",
            chosen_status:1,
            total_price:'',
            total_priceR:'',
            purchase_status:'',
        },
        transfer_type: "airplane",
        status: null,
        money_receipt: null,
        errors:{},
        loading: true,
        SubmitLoading: false,
        id:this.props.match.params.id,
        editMode:false,
        author:null,
        products:[],
        productsInit:[],
        files:[],
        get_user:null,
        set_user:null,
    };
    classes = this.props.classes;
    componentDidMount(){
        if(this.state.id){
            this.setState({
                editMode:true
            })
            this.loadData();
        }else{
            this.setState({
                loading:false
            })
        }
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }

    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/order/get/${this.state.id}`, config)
                .then(response => {
                    console.log(response.data)
                    this.setState({
                        fields: {
                            title: response.data.title,
                            tracking_code: response.data.tracking_code,
                            chosen_status: response.data.status.id,
                            description: !!response.data.description ? response.data.description : '' ,
                            total_price: !!response.data.total_price?  response.data.total_price: '' ,
                            total_priceR: !!response.data.total_price ? response.data.total_price: '' ,
                            customer_address:response.data.customer_address,
                            customer_phone:response.data.customer_phone,
                            target_link:!!response.data.target_link ? response.data.target_link: '' ,
                            purchase_status:response.data.purchase_status,
                        },
                        transfer_type: response.data.transfer_type,
                        money_receipt: response.data.money_receipt,
                        status:response.data.status,
                        author: response.data.user,
                        get_user: response.data.get_user,
                        set_user: response.data.set_user,
                    });

                    let tempProducts = [];
                    let tempProducts_ids = [];
                    let galleryTemp=[];
                    response.data.products.map(item => {
                        tempProducts.push(item)
                        tempProducts_ids.push(item.id)
                        return true
                    })
                    response.data.files.map(item =>{
                        galleryTemp.push({
                            src: `${defaultVariabls.uploads}/FileManager/${item.name}.${item.extension}`,
                            id: item.id,
                        })
                        return true
                    })
                    this.setState({
                        loading: false,
                        products: tempProducts_ids,
                        productsInit: tempProducts,
                        files: galleryTemp,
                    })
                }).catch(error => {
                    if(!error.response){
                        console.log(error)
                    }
                    else if(error.response.status === 404){
                        this.props.history.push(`/orders`);
                    }
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        if(target.name === "total_price"){
            fields.total_priceR = target.value.replace(/,/ig, '');
        }
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields,money_receipt} = this.state;
        let errors = {};
        let formIsValid = true;

        //title
        if(validator.isEmpty(fields.title)){
            formIsValid = false;
            errors['title'] = Translate.emptyField;
        }
        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 250) {
                formIsValid = false;
                errors['description'] = Translate.maxLength250;
            }
        }
        if(fields.purchase_status === "get_order"){
            if(!money_receipt){
                formIsValid = false;
                errors['purchase_status'] = Translate.moneyReceiptIsRequiredForThisStatus;
            }
        }
        if(fields.purchase_status === "set_order"){
            if(!fields.total_priceR){
                formIsValid = false;
                errors['purchase_status'] = Translate.totalPriceIsRequiredForThisStatus;
                errors['total_price'] = Translate.emptyField;
            }
        }
        if(fields.purchase_status === "delivery_to_customer"){
            if(fields.chosen_status !== 9){
                formIsValid = false;
                errors['purchase_status'] = Translate.statusShouldFinish;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    async handleRequest(){
        let { fields,id,editMode,transfer_type,money_receipt,products,files} = this.state;
        let data = new FormData();
        data.append('title', fields.title);
        data.append('transfer_type', transfer_type);
        data.append('description', fields.description);
        data.append('money_receipt', money_receipt);
        data.append('status', fields.chosen_status);
        data.append('customer_address', fields.customer_address);
        data.append('target_link', fields.target_link);
        data.append('customer_phone', fields.customer_phone);
        data.append('total_price', fields.total_priceR);
        data.append('products', JSON.stringify(products));

        data.append('id', id ? id : 0);
        if(files !== null){
            let ids = [];
            await files.map((row) =>{
                ids.push(row.id);
                return true
            })
            console.log(JSON.stringify(ids))
            await data.append('images', JSON.stringify(ids));

        }
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/order/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.orderEdited : Translate.orderAdded, {
                    variant: 'success',
                });
                console.log(response.data)
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                updateRedux();
                if(!editMode){
                    this.props.history.push(`/orders/make/${response.data.id}`);
                }else{
                    this.loadData();
                }

            })
            .catch(error => {
                this.props.enqueueSnackbar(editMode ?  Translate.orderEditingFailed : Translate.orderAddingFailed, {
                    variant: 'error',
                });
                console.log(error.response)
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }
    handleChangeProducts(products){
        let ids= [];
        products.map((product)=>{
            ids.push(product.id)
        })
        this.setState({
            products:ids
        })
    }
    async handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        await this.setState({
            publish: true
        })
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleStatus(id){
        let {fields,errors} = this.state;
        fields.chosen_status = id;
        errors["purchase_status"]='';
        this.setState({
            fields
        })
    }
    async handleMoneyReceipt(data){
        await this.setState({
            money_receipt: data,
        })
    }
    handleFilesChange(data){
        this.setState({
            files: data,
        })
    }
    render(){
        let {fields,errors,SubmitLoading,editMode,transfer_type,files,loading,money_receipt,productsInit,get_user,set_user} = this.state;
        return (
            <>
                <div className="mb-15">
                    <BreadCrumbs  firstText={Translate.orders} firstLink="/orders" secondText={editMode ? Translate.editOrder : Translate.makeOrder}/>
                </div>
                <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.makeOrder}>
                    {


                        <Grid container spacing={2} justify="center">
                            <Grid item xs={12} md={8} lg={9}>
                                <Grid container spacing={2} justify="center">
                                    <Grid item xs={12}>
                                        <AppCard
                                            title={editMode ? Translate.editOrder : Translate.makeOrder}
                                            action={
                                                <>
                                                {
                                                    this.props.width === "xs" || this.props.width === "sm" ? null :
                                                        <IconButton><AllInboxRoundedIcon color="primary"/></IconButton>
                                                }
                                                </>
                                            }>
                                            {
                                                this.state.loading ? <AppCardLoader/> :
                                                    <Grid container spacing={2} justify="center" alignItems="center">
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                margin="normal"
                                                                required
                                                                fullWidth
                                                                variant="outlined"
                                                                name="title"
                                                                label={Translate.orderTitle}
                                                                type="text"
                                                                id="title"
                                                                value={fields.title}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['title']}
                                                                helperText={errors['title']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                variant="outlined"
                                                                margin="normal"
                                                                multiline
                                                                fullWidth
                                                                required
                                                                name="description"
                                                                label={Translate.seoDescription}
                                                                placeholder={Translate.seoDescription}
                                                                type="text"
                                                                id="description"
                                                                rows="6"
                                                                value={fields.description}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['description']}
                                                                helperText={errors['description']}
                                                            />
                                                            <FieldCounter length={fields.description.length} max={250}/>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            <SubTitle align="left">{Translate.getOrderDetails}</SubTitle>
                                            <Divider/>
                                            {
                                                loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} className="mt-15">
                                                        <Grid item xs={12} md={6} lg={4}>
                                                            <>
                                                                <SubTitle align="left">{Translate.money_receipt}</SubTitle>
                                                                <Typography paragraph variant="body2">{Translate.money_receiptDesc}</Typography>
                                                                <FileChooserSingle initial={money_receipt} onChange={this.handleMoneyReceipt.bind(this)}/>
                                                            </>
                                                        </Grid>
                                                        {
                                                            !!money_receipt &&
                                                            <Grid item xs={12} md={6} lg={8}>
                                                                <ImageViewer id={money_receipt} style={{maxHeight:350}}/>
                                                            </Grid>
                                                        }
                                                        <Grid item xs={12}>
                                                            <SubTitle align="left">{Translate.orderFiles}</SubTitle>
                                                            <OrderFiles onChange={this.handleFilesChange.bind(this)} initial={files}/>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                margin="normal"
                                                                required
                                                                fullWidth
                                                                multiline
                                                                rows={3}
                                                                variant="outlined"
                                                                name="customer_address"
                                                                label={Translate.customer_address}
                                                                type="text"
                                                                id="customer_address"
                                                                value={fields.customer_address}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['customer_address']}
                                                                helperText={errors['customer_address']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                margin="normal"
                                                                required
                                                                fullWidth
                                                                variant="outlined"
                                                                name="customer_phone"
                                                                label={Translate.customer_phone}
                                                                type="text"
                                                                id="customer_phone"
                                                                value={fields.customer_phone}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['customer_phone']}
                                                                helperText={errors['customer_phone']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <SubTitle align="left">{Translate.productOfOrder}</SubTitle>
                                                            <Typography paragraph variant="body2">{Translate.productOfOrderDesc}</Typography>
                                                            <ProductChooser initial={productsInit} onChange={this.handleChangeProducts.bind(this)}/>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            <SubTitle align="left">{Translate.setOrderDetails}</SubTitle>
                                            <Divider/>
                                            {
                                                loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} className="mt-15">
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                margin="normal"
                                                                required
                                                                fullWidth
                                                                variant="outlined"
                                                                name="target_link"
                                                                label={Translate.target_link}
                                                                type="text"
                                                                id="target_link"
                                                                value={fields.target_link}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['target_link']}
                                                                helperText={errors['target_link']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <CurrencyTextField
                                                                variant="outlined"
                                                                required
                                                                fullWidth
                                                                margin="normal"
                                                                currencySymbol={currencySymbol}
                                                                decimalPlaces={0}
                                                                value={fields.total_price}
                                                                id="total_price"
                                                                label={Translate.totalPrice}
                                                                name="total_price"
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['total_price']}
                                                                helperText={errors['total_price']}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    {
                                        editMode ?
                                            <Grid item xs={12}>
                                            <AppCard>
                                                <SubTitle align="left">{Translate.orderTrackingCodeFull}</SubTitle>
                                                {
                                                    loading ? <AppCardLoaderFields/> :
                                                        <Grid container spacing={2} justify="center">
                                                            <Grid item xs={12} md={6}>
                                                                <Typography>{Translate.orderTrackingCode}</Typography>
                                                                <Typography>{fields.tracking_code}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Typography>{Translate.orderTrackingLink}</Typography>
                                                                <Typography>
                                                                    <Link target="_blank"
                                                                          href={`${defaultVariabls.React}/track/${fields.tracking_code}`}>
                                                                        {`${defaultVariabls.React}/track/${fields.tracking_code}`}
                                                                    </Link>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                }
                                            </AppCard>
                                        </Grid>
                                            : null
                                    }
                                    <Hidden smDown>
                                    <Grid item xs={12}>
                                        <LoadingButton
                                            variant="contained"
                                            color="primary"
                                            onClick = {this.handleSubmit.bind(this)}
                                            loading = {SubmitLoading}
                                        >
                                            {editMode ? Translate.editOrder : Translate.makeOrder }
                                        </LoadingButton>
                                    </Grid>
                                    </Hidden>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Grid container spacing={2} >
                                    {
                                        editMode &&
                                            <Grid item xs={12}>
                                                <AppCard>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <SubTitle align="left">{Translate.responsibles}</SubTitle>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className="my-10">{Translate.get_order_user}:
                                                                <strong> {!!get_user && get_user.first_name+" "+get_user.last_name}</strong>
                                                            </Typography>
                                                            <Divider/>
                                                            <Typography className="my-10">{Translate.set_order_user}:
                                                                <strong> {!!set_user && set_user.first_name+" "+set_user.last_name}</strong>
                                                            </Typography >
                                                        </Grid>

                                                    </Grid>
                                                </AppCard>
                                            </Grid>
                                    }
                                    <Grid item xs={12}>
                                        <AppCard>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <SubTitle align="left">{Translate.purchase_status}</SubTitle>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        select
                                                        variant="outlined"
                                                        fullWidth
                                                        name="purchase_status"
                                                        label={Translate.purchase_status}
                                                        value={fields.purchase_status}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['purchase_status']}
                                                        helperText={errors['purchase_status']}
                                                    >
                                                        <MenuItem  value='not_payed'>
                                                            {Translate.not_payed}
                                                        </MenuItem>
                                                        <MenuItem  value='get_order'>
                                                            {Translate.get_order}
                                                        </MenuItem>
                                                        <MenuItem value='set_order'>
                                                            {Translate.set_order}
                                                        </MenuItem>
                                                        <MenuItem value='delivery_to_customer'>
                                                            {Translate.delivery_to_customer}
                                                        </MenuItem>
                                                    </TextField>
                                                </Grid>

                                            </Grid>
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <SubTitle align="left">{Translate.transferType}</SubTitle>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Button
                                                        size="small"
                                                        variant={transfer_type === "airplane" ? "contained" : "outlined"}
                                                        onClick={() => this.setState({transfer_type:"airplane"})}
                                                        color={transfer_type === "airplane" ? "primary" : ""}
                                                        startIcon={
                                                            <Icon>
                                                                flight
                                                            </Icon>
                                                        }
                                                    >
                                                        {Translate.airplane}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Button
                                                        size="small"
                                                        variant={transfer_type === "ship" ? "contained" : "outlined"}
                                                        color={transfer_type === "ship" ? "primary" : ""}
                                                        onClick={() => this.setState({transfer_type:"ship"})}
                                                        startIcon={
                                                            <Icon>
                                                                directions_boat
                                                            </Icon>
                                                        }
                                                    >
                                                        {Translate.ship}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <SubTitle align="left">{Translate.chooseStatus}</SubTitle>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <StatusChooser
                                                        transfer_type={transfer_type}
                                                        current={fields.chosen_status}
                                                        handleStatus={this.handleStatus.bind(this)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </AppCard>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Hidden mdUp>
                                <Grid item xs={12}>
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        onClick = {this.handleSubmit.bind(this)}
                                        loading = {SubmitLoading}
                                    >
                                        {editMode ? Translate.editOrder : Translate.makeOrder }
                                    </LoadingButton>
                                </Grid>
                            </Hidden>
                        </Grid>

                    }
                </AppAnimate>
            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withWidth()(withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakeOrder)))));
